import { render, staticRenderFns } from "./animal.vue?vue&type=template&id=06ae0c50&"
import script from "./animal.vue?vue&type=script&lang=js&"
export * from "./animal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports